var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.08 2.93123C15.2649 1.11612 12.7621 0 10 0C7.23788 0 4.74634 1.11612 2.93123 2.93123C1.1274 4.73506 0 7.23788 0 10C0 12.7621 1.1274 15.2649 2.93123 17.0688C4.74634 18.8839 7.23788 20 10 20C12.7621 20 15.2649 18.8839 17.08 17.0688C18.8839 15.2649 20 12.7621 20 10C20 7.23788 18.8839 4.73506 17.08 2.93123ZM10 1.04848C12.4803 1.04848 14.7125 2.05186 16.336 3.67531C17.9481 5.28749 18.9515 7.531 18.9515 10C18.9515 12.469 17.9481 14.7125 16.336 16.3247C14.7125 17.9481 12.4803 18.9515 10 18.9515C7.531 18.9515 5.29876 17.9481 3.67531 16.3247C2.06313 14.7125 1.05975 12.469 1.05975 10C1.05975 7.531 2.06313 5.28749 3.67531 3.67531C5.29876 2.05186 7.531 1.04848 10 1.04848ZM6.24567 8.97407C6.03146 9.177 6.03146 9.50395 6.24567 9.71815L8.94014 12.4126C9.14307 12.6156 9.48129 12.6156 9.68422 12.4126L13.7654 8.33145C13.9683 8.12852 13.9683 7.7903 13.7654 7.58737C13.5625 7.38444 13.2242 7.38444 13.0213 7.58737L9.31218 11.2965L6.98975 8.97407C6.77554 8.75986 6.4486 8.75986 6.24567 8.97407Z",
    fill: "#707E8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksList);
export default __webpack_public_path__ + "static/media/tasks_list.62642bc2215da3982ed77be1acbf2c91.svg";
export { ForwardRef as ReactComponent };